import i18n from "@/i18n";
import { getCookie, setCookie } from "../../utilities/cookieHelper";
import router from "@/router";
import { inject, injectable } from "inversify";
import IAlertService from "../alert/IAlertService";
import { AuthApi } from "../api/AuthApi";
import { DiTokens } from "../diTokens";
import ISessionService from "./ISessionService";

@injectable()
/**Сервис для работы с сессией */
export default class SessionService implements ISessionService {
  constructor(
    @inject(DiTokens.AlertService) private alertService: IAlertService
  ) {}

  public sessionLifeTime: number = 15

  public sessionTimeOut: number = 15 * 60 * 1000
  // /**Стор настроек */
  // get configStore(): ConfigStore {
  //   return getModule(ConfigStore, store);
  // }

  /**
   * Пинг сессии
   * @param needRedirect Признак необходимости редиректа
   * @param checkOnServer Признак необходимости проверки на сервере
   * @param refreshSession Обновить данные сессии
   */
  public async sessionPing(
    needRedirect: boolean,
    checkOnServer: boolean,
    refreshSession: boolean
  ): Promise<boolean> {
    let result = false;
    try {
      let sessionTimeout = parseInt(getCookie("fspbSessionTimeout"));
      let timeoutDelta = isNaN(sessionTimeout)
        ? 100 * 60 * 1000
        : Date.now() - sessionTimeout;

      if (timeoutDelta < 0) {
        if (checkOnServer) {
          await AuthApi.sessionPing();
        }
        result = true;
      } else if (timeoutDelta < 30 * 60 * 1000) {
        await this.timeoutSession(needRedirect);
      } else {
        await this.clearSession();
      }

      if (result && refreshSession) {
        setCookie(
          "fspbSessionTimeout",
          (Date.now() + this.sessionLifeTime * 60 * 1000).toString(),
          '/'
        );
      }

      sessionTimeout = parseInt(getCookie("fspbSessionTimeout"));
      timeoutDelta = Date.now() - sessionTimeout;

      this.sessionTimeOut = parseInt(
        (Math.abs(timeoutDelta) / 1000).toString()
      );
    } catch (e) {
      if (e.name.indexOf("401") >= 0) {
        this.timeoutSession(needRedirect);
      } else {
        this.alertService.error(e.message);
      }
    }
    return result;
  }

  /**
   * Выйти из системы
   * @param needRedirect Признак необходимости редиректа
   */
  public async logoutSession(needRedirect: boolean): Promise<void> {
    await this.clearSession();
    try {
      await AuthApi.logout();
    } catch (e) {
      console.log(e);
    }
    if (needRedirect) router.push("/login");
    this.alertService.info(i18n.t("auth.messages.logout").toString());
  }
  /**
   * Таймаут сессии
   * @param needRedirect Признак необходимости редиректа
   */
  public async timeoutSession(needRedirect: boolean): Promise<void> {
    await this.clearSession();
    if (needRedirect) router.push("/login");
    this.alertService.info(i18n.t("auth.messages.sessionEnd").toString());
  }

  /**
   * Установка данных сессии
   * @param userName Имя пользователя сессии
   */
  public async setSession(userName: string): Promise<void> {
    setCookie(
      "fspbSessionTimeout",
      (Date.now() + this.sessionLifeTime * 60 * 1000).toString()
    );
    setCookie("fspbUser", userName);
  }

  /**Закрыть сессию */
  public async clearSession(): Promise<void> {
    setCookie("fspbSessionTimeout", "");
    setCookie("fspbUser", "");
  }
}
